import { render, staticRenderFns } from "./eventForm.vue?vue&type=template&id=80a6fae8&scoped=true&"
import script from "./eventForm.vue?vue&type=script&lang=js&"
export * from "./eventForm.vue?vue&type=script&lang=js&"
import style0 from "./eventForm.vue?vue&type=style&index=0&id=80a6fae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a6fae8",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QCard,QInput,QSelect,QCheckbox});
